﻿

/*------------------------------------*\
    #TAB-NAVIGATION
\*------------------------------------*/


window.gro = window.gro || {};
gro.modules = gro.modules || {};


gro.modules.tabNavigation = (function () {
    var priv = {};

    /**
     * Private initialization method
     */
    priv.init = function () {

        /**
         * Navigate to correct tab if provided in url (e.g. ?tab=name)
         */
        if ($(".js-tab").length) {
            var tab = gro.modules.url.getUrlParam("tab");

            if (tab) {
                // Switch to tab provided in querystring
                priv.switchTab(tab);
            } else {
                // Switch to first tab
                var firstTab = $(".js-tab").first().data("tab");
                priv.switchTab(firstTab);
            }
        }

        /**
         * Click on tab
         */
        $(document).on("click", ".js-tab", function (e) {
            e.preventDefault();
            var tabName = $(this).data("tab");
            var updateUrl = $(this).data("tab-url");
            var extraDataKey = $(this).data("extra-data-key");
            var extraDataValue = $(this).data("extra-data-value");

            if (updateUrl) {
                // Add tab to querystring
                gro.modules.url.addUrlParam(null, "tab", tabName);
            }
            if (extraDataKey && extraDataValue) {
                gro.modules.url.addUrlParam(document.location.search, extraDataKey, extraDataValue);
            }

            // Switch tab
            priv.switchTab(tabName);
        });
    };

    /**
     * Switch to tab
     * @param {string} tab - The name of the tab that was clicked
     */
    priv.switchTab = function (tab) {
        var control = $("[data-tab='" + tab + "']");
        var target = $(control).data("tab");

        if (control.length) {
            if (!$(control).hasClass("is-active")) {
                $(control)
                    .addClass("is-active")
                    .siblings(".tab-navigation__tab")
                    .removeClass("is-active");

                $(control)
                    .closest(".tab-navigation__tab-container")
                    .next(".tab-navigation__tab-content-container")
                    .find(".tab-navigation__tab-content")
                    .removeClass("is-active")
                    .filter("[data-tab='" + target + "']")
                    .addClass("is-active");
            }
        }
    };

    // Initialize module
    $(function () {
        priv.init();
    });

})();
